var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "columns" },
    _vm._l(_vm.plans, function(plan, index) {
      return _c("div", { staticClass: "column d-flex flex-column" }, [
        _c("div", { staticClass: "card card-subscription h-100" }, [
          _c(
            "div",
            {
              staticClass:
                "card__heading border-radius-top bg-navy pt-5 pb-3 text-center shape shape--top-large"
            },
            [
              _c(
                "div",
                {
                  staticClass: "fs-18 t-orange lh-lg font-weight-semi-bold mb-1"
                },
                [_vm._v(_vm._s(plan.name))]
              ),
              _vm._v(" "),
              _c("div", {}, [
                _c("div", { staticClass: "h1 t-white" }, [
                  _vm._v("£" + _vm._s(plan.price))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "h6 font-weight-normal t-disabled text-uppercase"
                  },
                  [_vm._v("Per Month")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "card__content p-1 p-sm-3 pt-4" }, [
            _c(
              "ul",
              { staticClass: "px-2" },
              [
                _vm._l(plan.features, function(feature, i) {
                  return [
                    _c(
                      "li",
                      {
                        staticClass: "li-check font-weight-light lh-lg",
                        class: { "mb-12px": i !== plan.features.length }
                      },
                      [_vm._v(_vm._s(feature) + "\n                        ")]
                    )
                  ]
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "p-2 p-sm-3 mt-auto" },
            [
              index === 0 ? _vm._t("buttonOne") : _vm._e(),
              _vm._v(" "),
              index === 1 ? _vm._t("buttonTwo") : _vm._e()
            ],
            2
          )
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-395c7b9b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-395c7b9b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Subscriptions.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-395c7b9b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Subscriptions.vue
// module chunks = 0 1